<template>
  <div id="Reply">
    답변 {{count||0}}
  </div>
</template>

<script>
export default {
  name: 'Reply',
  props: ['count'],
  data: function () {
    return {
    }
  },
  computed: {},
  created() {
  },
  destroyed() {},
  methods: {
  },
}
</script>

<style lang="scss" scoped>
  #Reply {
    width: 100%;
    height: 100%;
    font-weight: 700;
    font-size: 16px;
    letter-spacing: -0.11px;
    color: #8a94a2;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
